/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { Button, Space, Text } from '@cashfree-intl/coherent';

import { DEFAULT_LIMIT_OPTIONS } from 'utils/constants';
import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import ExternalPMRTable from './ExternalPMRTable';
import { HEADINGS_V2 as HEADINGS } from '../constants';


const PaymentMethodRateTable = ({
  filters,
  hasPrev,
  hasNext,
  onPageChange,
  onLimitChange,
  rowData,
  isLoading,
  onExternalPMRToggle,
  onExternalPMREdit,
  onUpdateClick,
}: any) => {
  const [selectedRecordIds, setSelectedRecordIds] = useState({});

  const FORMATTED_COLUMN_ID = formatColumns(HEADINGS);

  const combinedColumn = {
    accessorKey: 'status',
    header: 'TDR Status',
    ellipsis: true,
    width: 350,
    cell: ({ status, toggle, actions }) => (
      <Space alignItems="center" gap={6} >
        {status()}
        {toggle()}
        {actions()}
      </Space>
    ),
  };

  const updatedColumnId = [...FORMATTED_COLUMN_ID.slice(0, -3), combinedColumn];

  const rowSelectionInfo = {
    primaryKey: 'id',
    selectedRecordIds,
    onChange: row => {
      setSelectedRecordIds(row);
    },
    renderRowSelectionAction: () => (
      <Button
        primary
        onClick={onUpdateClick}
        data-event-name="Primary_Button_Update"
        data-ignore-inner-text="true"
      >
        Update{' '}
        {
          Object.keys(selectedRecordIds).filter(key => !!selectedRecordIds[key])
            .length
        }{' '}
        Items
      </Button>
    ),
  };

  const renderExpandedContent = record => {
    const { merchantExternalPMRConditions } = record || {};
  
    return (
      merchantExternalPMRConditions?.length > 0 ? (
        <Space direction="column"  className="pl-2 mb-2">
          <Text variant="h16" className="mt-3 mb-1">
            Slabs
          </Text>
          <ExternalPMRTable
            data={merchantExternalPMRConditions}
            onToggleClick={index => onExternalPMRToggle(record, index)}
            onEditClick={index => onExternalPMREdit(record, index)}
          />
        </Space>
      ):null
    );
  };

  return (
      <PaginatedTable
        data={rowData}
        tableHeading={updatedColumnId}
        limit={filters.pageSize}
        limitOptions={DEFAULT_LIMIT_OPTIONS}
        hasPrev={hasPrev}
        hasNext={hasNext}
        currentPage={filters.pageNo}
        currentPageCount={rowData.length}
        onPageChange={onPageChange}
        onLimitChange={onLimitChange}
        withSelect={rowSelectionInfo}
        rowExpansion={renderExpandedContent}
        fetching={isLoading}
      />
  );
};

export default PaymentMethodRateTable;
